export default __webpack_public_path__ + "static/buying-property-img-m-9d1bac8ac114008e16987c4684c2fdf8.jpg";